module.exports = __webpack_public_path__ + "static/message2-f03819b3b26c12a050e6a3aa693f4d12.jpg";